import { createSelector } from '@reduxjs/toolkit';

import { projectSensitivePropertyGroupsByNameSelector } from 'src/selectors/projectSensitivePropertyGroupsByName';

export const projectSensitivePropertyGroupNamesSelector = (projectId: string) =>
  createSelector(
    projectSensitivePropertyGroupsByNameSelector(projectId),
    (sensitivePropertyGroupsByName) =>
      Object.keys(sensitivePropertyGroupsByName)
  );
